<template>
    <a v-if="navdata.contactLink" class="btn btn--primary" :href="navdata.contactLink.url">Kontakt</a>
    <button class="hamburger" @click="toggleNavPanel" type="button" :class="{ 'hamburger--active': state.navActive }" aria-label="Meny">
        <span></span>
    </button>
    <Transition name="navslide">
        <div class="mobilenav__panel" v-if="state.navActive === true" ref="lockScroll">
            <div class="container-fluid-max">
                <ul class="mobilenav__main-items">
                    <li v-for="(navItem, spotIndex) in navdata.mainNavItems">
                        <a :href="navItem.url">{{navItem.name}}</a>
                    </li>
                </ul>
                <ul class="mobilenav__secondary-items">
                    <li v-if="navdata.showLangNav">
                        <a @click.prevent="openLangModal" class="navigation__hover icon icon--lang icon--bark-dark open-lang" href="#modal-lang">Language</a>
                    </li>
                    <li v-if="navdata.showSearch">
                        <a @click.prevent="openSearchModal" class="icon icon--search icon--bark-dark open-search-form" href="#modal-search">Sök</a>
                    </li>
                    <li v-if="navdata.myPagesLink">
                        <a class="icon icon--member icon--bark-dark " href="#">Mina sidor</a>
                    </li>
                </ul>
            </div>
        </div>
    </Transition>
</template>
<script setup>
    import { reactive, ref } from 'vue';
    import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
    const state = reactive({
        navActive: false
    });

    const props = defineProps({
        navdata: {
            type: Object
        }
    });

    //, onMounted
    //onMounted(() => {
    //    console.log('props.navdata',props.navdata)
    //})

    const lockScroll = ref(null);

    const toggleNavPanel = (event) => {
        if (!state.navActive) {
            state.navActive = true;
            setTimeout(() => {
                disableBodyScroll(lockScroll);
            }, 100)
        }
        else {
            enableBodyScroll(lockScroll);
            state.navActive = false;
        }
    }

    const openSearchModal = () => {
        const searchModal = document.getElementById('modal-search');
       
        if (!searchModal) return

        const input = searchModal.querySelector('input')
        disableBodyScroll(searchModal)
        searchModal.hidden = false
        if (input) {
            input.focus()
        }
    }

    const openLangModal = () => {
        const langModal = document.getElementById('modal-lang')

        if (!langModal) return

        disableBodyScroll(langModal)
        langModal.hidden = false;       
    }
    /* Lifecycle Hooks -------------------*/
    //onMounted(() => {
    //    //state.contactLink = props.navdata.ContactLink;
    //    //state.mainNavItems = props.navdata.MainNavItems;
    //    //state.myPagesLink = props.navdata.MyPagesLink;
    //    //state.showSearch = props.navdata.ShowSearch;
    //    //state.showLangNav = props.navdata.ShowLangNav;
    //});
</script>
